import { AiFeatureKind } from "@/modules/chats/types/chat-message"

const CLIENT_SIDE_TEMPLATE_AI_FEATURES: readonly AiFeatureKind[] = ["GREETING"]

export const hasAiGeneratedContent = (aiFeatures: AiFeatureKind[] | undefined): boolean =>
  Array.isArray(aiFeatures) && aiFeatures.some((aiFeature) => !CLIENT_SIDE_TEMPLATE_AI_FEATURES.includes(aiFeature))
